/**
 * พรแห่งตะเกียง — บัฟเริ่มต้นจาก NPC ผู้ดูแลตะเกียงในทุกเมือง (ผู้ใช้สั่ง 9 ต.ค. 2026)
 * ค่าทั้งหมดอยู่ที่ `data/balance.json` (`blessing`) · server ตัดสินจริง client ใช้แสดงราคา/ชื่อ
 */
import balanceJson from "./data/balance.json" with { type: "json" };
export const BLESSING_ID = "lantern_blessing";
export const BLESSING_TH = "พรแห่งตะเกียง";
export const BLESSING = balanceJson.blessing;
/** ราคาโกลด์ที่เลเวลนี้ (0 = ฟรี) */
export function blessingCost(baseLevel) {
    return baseLevel <= BLESSING.freeUntil ? 0 : Math.round(BLESSING.goldPerLv * baseLevel);
}
/** คำบรรยายผล (สร้างจากข้อมูล) */
export function describeBlessing() {
    return `DEF +${BLESSING.flatDef} · คริ +${BLESSING.flatCrit}% · ความเร็วตี +${Math.round((BLESSING.aspdMul - 1) * 100)}% · ${BLESSING.seconds / 60} นาที (ตายแล้วหาย)`;
}
//# sourceMappingURL=blessing.js.map